export type WorkerAPI<T, R> = {
  on: (handler: (data: R) => void) => void
  send: (message: T) => void
}
